"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Popover_native_exports = {};
__export(Popover_native_exports, {
  Popover: () => Popover
});
module.exports = __toCommonJS(Popover_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react_native = require("react-native");
var import_Containers = require("./Containers.native");
var import_controlled = require("./controlled");
var import_swiftui = require("./generated/swiftui");
var import_OneNativePopoverContentNativeComponent = __toESM(require("./specs/OneNativePopoverContentNativeComponent"), 1);
var import_OneNativePopoverNativeComponent = __toESM(require("./specs/OneNativePopoverNativeComponent"), 1);
function Popover(param) {
  var { isPresented, onIsPresentedChange, revision = 0, arrowEdge, presentationCompactAdaptation = "automatic", contentWidth, contentHeight, content, children, style, ...props } = param;
  if (typeof isPresented !== "boolean") throw new Error("Swift.Popover isPresented must be a boolean");
  if (!Number.isFinite(contentWidth) || contentWidth <= 0) throw new Error("Swift.Popover contentWidth must be a positive number");
  if (!Number.isFinite(contentHeight) || contentHeight <= 0) throw new Error("Swift.Popover contentHeight must be a positive number");
  var iosVersion = Number.parseFloat(String(import_react_native.Platform.Version));
  if (arrowEdge !== void 0) (0, import_swiftui.assertSwiftUIValue)("Edge", arrowEdge, iosVersion);
  (0, import_swiftui.assertSwiftUIValue)("PresentationAdaptation", presentationCompactAdaptation, iosVersion);
  (0, import_Containers.assertOneNativeChildren)(children, "Swift.Popover");
  var controlled = (0, import_controlled.useControlled)(function(event) {
    return onIsPresentedChange(event.isPresented);
  }, revision);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_OneNativePopoverNativeComponent.default, {
    ...props,
    style: [
      {
        alignSelf: "stretch"
      },
      style
    ],
    isPresented,
    revision,
    acknowledgedEvent: controlled.acknowledgedEvent,
    arrowEdge: arrowEdge !== null && arrowEdge !== void 0 ? arrowEdge : "",
    presentationCompactAdaptation,
    contentWidth,
    contentHeight,
    onNativePopoverIsPresentedChange: function onNativePopoverIsPresentedChange(param2) {
      var { nativeEvent } = param2;
      return controlled.onNativeChange(nativeEvent);
    },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Containers.InsideContainer, {
        value: true,
        children
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativePopoverContentNativeComponent.default, {
        collapsable: false,
        style: {
          position: "absolute",
          left: 0,
          top: 0
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Containers.InsideContainer, {
          value: false,
          children: content
        })
      })
    ]
  });
}
//# sourceMappingURL=Popover.native.js.map
